import React from 'react';
import SVG from 'react-inlinesvg';
import { Icon, Link, Text } from '@perch-labs/shrike';
import { Card, Container } from 'styles';
import { copyFor } from 'config';
import { vnmExplainerGuide, vnmExplainerBlog } from 'domain/vnm';
import SolarPanelsImage from '/images/solar/single-solar-panel.svg';

const getCopy = copyFor('solar.explainer');

export const SolarExplainer = () => {
  return (
    <Card mobileVariant="flat">
      <Card.Header>
        <Container>
          <Text
            textStyle="heading700"
            tag="h2"
            margin={{ bottom: '8px', right: '8px' }}
          >
            {getCopy('title')}
          </Text>
          <Container flex alignItems="center">
            <Icon icon="OpenBook" opacity="medium" />
            <Text
              margin={{ left: '8px' }}
              opacity="medium"
              textStyle="paragraph400"
            >
              {getCopy('subTitle')}
            </Text>
          </Container>
        </Container>
        <SVG src={SolarPanelsImage} width="109" />
      </Card.Header>
      <Card.Content>
        <Text margin={{ top: '16px' }}>{getCopy('text1')}</Text>
        <Text margin={{ top: '16px' }}>
          {getCopy('text2')}
          <Link type="inline" href={vnmExplainerGuide}>
            {getCopy('links.guide')}
          </Link>
          {getCopy('text3')}
          <Link type="inline" href={vnmExplainerBlog}>
            {getCopy('links.blog')}
          </Link>
          .
        </Text>
      </Card.Content>
    </Card>
  );
};
